<template>
  <div aria-live="assertive">
    <div class="flex w-full flex-col  space-y-4 mb-4">
      <h3 class="text-base font-semibold leading-6 text-gray-900 mb-2">
        Preview
      </h3>
      <div
        class="pointer-events-auto flex w-full max-w-md divide-x divide-gray-200 rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5"
      >
        <div class="flex w-0 flex-1 items-center p-4">
          <div class="w-full">
            <p class="text-sm font-medium text-gray-900">
              {{ title }}
            </p>
            <p class="mt-1 text-sm text-gray-500">
              {{ description }}
            </p>
          </div>
        </div>
        <div class="flex" v-if="!hideAction">
          <div class="flex flex-col divide-y divide-gray-200">
            <div class="flex h-0 flex-1">
              <button
                type="button"
                class="flex w-full items-center justify-center rounded-none rounded-tr-lg border border-transparent px-4 py-3 text-sm font-medium text-indigo-600 hover:text-indigo-500 focus:z-10 focus:outline-none focus:ring-2 focus:ring-indigo-500"
              >
                Reply
              </button>
            </div>
            <div class="flex h-0 flex-1">
              <button
                type="button"
                class="flex w-full items-center justify-center rounded-none rounded-br-lg border border-transparent px-4 py-3 text-sm font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
              >
                Don't allow
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title", "description", "hideAction"]
};
</script>

<style></style>
